import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import {
  NotEnrolledError,
  OrgQualificationContext,
  getOrgQualificationContext,
} from '@/services/workflow/qualification';

export const ORG_QUALIFICATION_CONTEXT_QUERY_KEY = 'org-qualification-context';

export const useOrgQualificationContext = (
  orgId: string | undefined,
  options?: Partial<UseQueryOptions<OrgQualificationContext, Error>>,
) =>
  useQuery<OrgQualificationContext, Error>({
    queryKey: [ORG_QUALIFICATION_CONTEXT_QUERY_KEY, orgId],
    queryFn: async ({ signal }) => {
      if (!orgId) throw new Error('No org ID');
      return getOrgQualificationContext(orgId, signal);
    },
    enabled: !!orgId,
    // A ladder changes when an admin repoints a rung, which is rare, and
    // the answer drives which action every row offers. Cached for the
    // session rather than refetched per render.
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    // Most orgs are in no ladder at all. That is a settled answer, not a
    // transient failure, and retrying it on every workflow page is noise.
    retry: (failureCount, error) =>
      error instanceof NotEnrolledError ? false : failureCount < 2,
    ...options,
  });
